module.exports = __webpack_public_path__ + "img/DE04051.d7a122b2.png";